const chartColors = {
    revenue: '#FF3B30',
    attendance: '#00C853',
    growth: '#3498db',
    plans: ['#3498db', '#e74c3c', '#2ecc71', '#f1c40f', '#9b59b6'],
    trainers: '#f39c12',
    enquirySources: ['#3498db', '#9b59b6', '#2ecc71', '#f1c40f'],
    enquiryStatuses: ['#00C853', '#FF3B30', '#f39c12', '#3498db'],
};
const commonOptions = {
    grid: { top: 30, right: 20, bottom: 50, left: 60 },
    tooltip: { trigger: 'axis' },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLine: { lineStyle: { color: '#ccc' } },
        axisLabel: { color: '#666' },
    },
    yAxis: {
        type: 'value',
        axisLine: { show: false },
        axisLabel: { color: '#666' },
        splitLine: { lineStyle: { type: 'dashed', color: '#eee' } },
    },
    legend: {
        show: true,
        bottom: 0,
        textStyle: {
            color: '#333'
        }
    },
    responsive: true,
    maintainAspectRatio: false,
};
export const getChartDataOptions = (type, dashboardData = {}) => {
    console.log("dashboardData", dashboardData);

    switch (type) {
        case 'revenue':
            const rawRevenue = dashboardData.all_month_revenue || [];
            const revenueMap = {};
            rawRevenue.forEach(item => {
                revenueMap[`${item.month}-${item.year}`] = item.total;
            });

            // Generate last 6 months (month + year)
            const last6Months = [];
            for (let i = 5; i >= 0; i--) {
                const d = new Date();
                d.setMonth(d.getMonth() - i);

                last6Months.push({
                    month: d.toLocaleString("en-US", { month: "short" }),
                    year: d.getFullYear()
                });
            }

            // Build final arrays with fallback 0
            const revenueMonths = last6Months.map(m => m.month);
            const revenueValues = last6Months.map(m => {
                const key = `${m.month}-${m.year}`;
                return revenueMap[key] ?? 0;
            });

            return {
                ...commonOptions,
                xAxis: {
                    ...commonOptions.xAxis,
                    data: revenueMonths
                },
                series: [{
                    name: 'Revenue',
                    type: 'line',
                    smooth: true,
                    data: revenueValues,
                    itemStyle: { color: chartColors.revenue },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0, y: 0, x2: 0, y2: 1,
                            colorStops: [
                                { offset: 0, color: chartColors.revenue },
                                { offset: 1, color: 'rgba(255, 59, 48, 0.1)' }
                            ]
                        }
                    },
                }],
                yAxis: {
                    ...commonOptions.yAxis,
                    axisLabel: {
                        ...commonOptions.yAxis.axisLabel,
                        formatter: 'OMR {value}'
                    }
                },
            };


        case 'attendance':
            const attendanceData = dashboardData.attendance || [];

            const attendanceDays = attendanceData.map(item => item.day);
            const attendanceCounts = attendanceData.map(item => item.count);

            return {
                ...commonOptions,
                xAxis: {
                    ...commonOptions.xAxis,
                    data: attendanceDays,
                    boundaryGap: true
                },
                series: [{
                    name: 'Attendance',
                    type: 'bar',
                    data: attendanceCounts,
                    itemStyle: {
                        color: chartColors.attendance,
                        borderRadius: [4, 4, 0, 0]
                    }
                }]
            };

        case 'growth':
            const growthData = dashboardData.member_growth || [];

            // Convert month number → month name
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            const growthMonths = growthData.map(item => monthNames[item.month - 1]);
            const growthCounts = growthData.map(item => item.count);

            return {
                ...commonOptions,
                xAxis: {
                    ...commonOptions.xAxis,
                    data: growthMonths
                },
                series: [{
                    name: 'New Members',
                    type: 'line',
                    smooth: true,
                    data: growthCounts,
                    itemStyle: { color: chartColors.growth },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0, y: 0, x2: 0, y2: 1,
                            colorStops: [
                                { offset: 0, color: chartColors.growth },
                                { offset: 1, color: 'rgba(52, 152, 219, 0.1)' }
                            ]
                        }
                    }
                }]
            };

    }
};
